import type { MessageId } from '@/lib/i18n';

export interface NavItem {
  to: string;
  labelKey: MessageId;
}

/** The home page — the first link of the primary navigation on every device (D-315). */
export const HOME_LINK: NavItem = { to: '/', labelKey: 'nav.home' };

/**
 * The centred jump-link pill (≥ lg), the mobile menu list and the footer's sitemap, in this order (D-319):
 * Home · Our Collections (the shop) · Visualizer · Where to Use · Gallery · Contact us (D-322, D-329, D-331: the same
 * order as the three cards under the home hero; D-332 adds Gallery before Contact us).
 * `Shop` is also a pill of its own, always visible in the header bar (also on mobile).
 */
export const JUMP_LINKS: readonly NavItem[] = [
  HOME_LINK,
  { to: '/shop', labelKey: 'nav.collection' },
  { to: '/visualizer', labelKey: 'nav.visualizer' },
  { to: '/where-to-use', labelKey: 'nav.applications' },
  { to: '/gallery', labelKey: 'nav.gallery' },
  { to: '/contact-us', labelKey: 'nav.contact' },
];

export const SHOP_LINK: NavItem = { to: '/shop', labelKey: 'nav.shop' };

/** Sitemap column in the footer: the same links as the header, so "Our Collections" is its way to the shop. */
export const SITEMAP_LINKS: readonly NavItem[] = JUMP_LINKS;

export const LEGAL_LINKS: readonly NavItem[] = [
  { to: '/legal-disclaimer', labelKey: 'footer.legalDisclaimer' },
];
